'use client';

import IconLabel from '../IconLabel/IconLabel';
import { IconPeopleGroup } from '@justgiving/carepack-icons';
import React from 'react';
import clientConfig from '../../client/config';
import { useIsPageOwner } from '../../hooks/useIsPageOwner';
import { usePage } from '../Providers/PageProvider';
import { useTranslation } from 'react-i18next';
import { useDecision } from '@optimizely/react-sdk';
import { Link } from '../Link/Link';
import classNames from 'classnames';

type Props = {
  className?: string;
};

export const CreateTeam = ({ className }: Props) => {
  const { t } = useTranslation();
  const isPageOwner = useIsPageOwner();
  const { id } = usePage();
  const [decision] = useDecision('page_content_restructure');

  if (!isPageOwner) {
    return null;
  }

  if (decision.variationKey === 'restructured') {
    return (
      <Link
        href={`${clientConfig.justGivingRootUrl}/create-page/team?fundraisingPageId=${id}`}
        className={classNames('cp-body-small', className)}
      >
        {t('team.createTeam')}
      </Link>
    );
  }

  return (
    <IconLabel>
      <IconLabel.Icon>
        <IconPeopleGroup />
      </IconLabel.Icon>
      <IconLabel.Label>
        <Link
          href={`${clientConfig.justGivingRootUrl}/create-page/team?fundraisingPageId=${id}`}
          className={className}
        >
          {t('team.createTeam')}
        </Link>
      </IconLabel.Label>
    </IconLabel>
  );
};
